import { useToastStore } from '../store/toastStore'
import type { ToastType } from '../store/toastStore'

export function useToast() {
  const show = useToastStore((state) => state.show)
  
  return {
    success: (message: string) => show(message, 'success'),
    error: (message: string) => show(message, 'error'),
    warning: (message: string) => show(message, 'warning'),
    info: (message: string) => show(message, 'info'),
    show: (message: string, type?: ToastType) => show(message, type),
  }
}

